const CompanyLogo = ({ logoUrl, altText = 'Company Logo' }) => {
  const styles = {
    logo: {
      maxHeight: '120px',
      display: 'block',
    },
  };

  return <img src={logoUrl} alt={altText} style={styles.logo} />;
};

export default CompanyLogo;
